import React from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import './assets/styles/index.scss'; 
import SignIn from './pages/SignIn/SignIn';
import Home from './pages/Home/Home';
import Error404 from './pages/Error404/Error404';
import ServicePage from './pages/ServicePage/ServicePage';
import AboutUs from './pages/AboutUs/AboutUs';
import { LanguageProvider } from './context/LanguageContext/LanguageContext';
import RequestForm from './pages/RequestForm/RequestForm';
import RequestPricePage from './pages/RequestPricePage/RequestPricePage';
import MyAccount from './pages/MyAccount/MyAccount';
import Profile from './components/MyAccount/Profile';
import Notifications from './components/MyAccount/Notifications';
import Units from './components/MyAccount/units/Units';
import AddUnit from './components/MyAccount/units/AddUnit';
import OrderTable from './components/MyAccount/Order/OrderTable';
import OrderDetails from './pages/OrderDetails/OrderDetails';
import AttachmentTable from './components/MyAccount/AttachmentTable/AttachmentTable';
import Contracts from './pages/Contracts/Contracts';
import ContractDetails from './pages/Contracts/ContractDetails';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <>
  <LanguageProvider>
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />}>
        <Route index element={<Home />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignIn />} />   
        <Route path="/forget-password" element={<SignIn />} />
        <Route path="/service/:id" element={<ServicePage />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/new-request" element={<RequestForm />} />
        <Route path="/request-price" element={<RequestPricePage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/my-account" element={<MyAccount />}>
          <Route path="profile" element={<Profile />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="units" element={<Units />} />
          <Route path="add-unit" element={<AddUnit />} />
          <Route path="orders" element={<OrderTable />} />
          <Route path="contracts" element={<Contracts />} />
          <Route path="attachments" element={<AttachmentTable />} />
          <Route path="orders/:orderId" element={<OrderDetails />} />
          <Route path="contracts/:id" element={<ContractDetails />} />
        </Route>
        {/* <Route path="/profile" element={<ProfilePage />} />
        <Route path="/account-settings" element={<AccountSettingsPage />} /> */}
        <Route path="*" element={<Error404 />} />
      </Route>
    </Routes>
  </BrowserRouter>
  </LanguageProvider>
  </>
  </Provider>
);
